import { createCarousel } from './src/callisto-carousel.mjs';
import { getConfigOptions } from './src/config-options.mjs';

(function (Drupal) {
    Drupal.behaviors.callistoCarousel = {
        attach: function (context, settings) {
            once("callisto-carousel", ".splide", context).forEach((element) => {

                const options = getConfigOptions(element);
                if (!options) {
                    console.error("No options found for carousel component");
                    return;
                }

                createCarousel(element, options);
            });
        },
    };
})(Drupal);
